import { Injectable, signal, WritableSignal } from '@angular/core';
import { NavigationEnd, NavigationSkipped, Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProgressLoadingService {
	public get loadingState(): boolean {
		return this.loading();
	}

	public loading: WritableSignal<boolean> = signal(false);

	private currentUrl: string;
	constructor(private readonly router: Router) {
		this.router.events
			.pipe(filter((event) => event instanceof RoutesRecognized || event instanceof NavigationEnd || event instanceof NavigationSkipped))
			.subscribe((event) => {
				const triggeredUrl = event.url.split('?')[0];
				let timeout;
				if (event instanceof RoutesRecognized && this.currentUrl !== triggeredUrl) {
					if (timeout) clearTimeout(timeout);
					this.loading.set(true);
					this.currentUrl = triggeredUrl;
				}
				if (event instanceof NavigationEnd || event instanceof NavigationSkipped) {
					// timeout = setTimeout(() => {
					this.loading.set(false);
					this.currentUrl = triggeredUrl;
					// }, 1000);
				}
			});
	}
}
